/* eslint-disable max-len */
import { flowResult, toJS } from 'mobx';
import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactNotifications, VideoPlayer } from '../../../components';
import { COURSE_STATUS_COMPLETE, COURSE_TYPE, COURSE_TYPE_STRING, DATE_TIME_YMD, DATE_YMD, LEVEL_COURSE_STRING, MSG, SYSTEM_PATH, THEME_TYPE } from '../../../core/configs/constants';
import { convertVideoDuration, extractContent, formatScheduledPublishDateJP, formatTimeFromVideoLength, isPublicDateAfterTodayJP, numberWithCommas } from '../../../core/utils/common';
import { useStore } from '../../../core/utils/hook';
import { useBuyCourse } from '../../../core/utils/useBuyCourse';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { Pie } from 'react-chartjs-2';
import moment from 'moment';
import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { isShowCancelButton, isShowCompletionTest, isShowCourseStatus, isShowJoinCourse, isShowReStudy, isShowReTest, isViewOldCourse } from '../ultis/courses.ultis';


import './styles.scss';
import { observer } from 'mobx-react';
import ExpandableContent from './ExpandableContent';
import { color } from 'd3';

const data = {
    labels: ['受講中または受講完了', ' 未受講'],
    datasets: [
        {
            label: '受講割合',
            data: [0, 0],
            backgroundColor: [
                '#fbb03b',
                '#0077b6'
            ]
        }
    ]
};

const CourseCard = observer(({ course, onFetchData, handleSearch }) => {
    const [dataPieChart, setDataPieChart] = useState(data)
    const [showMore, setShowMore] = useState(false);
    const [isShowTitleVideoSample, setIsShowTitleVideoSample] = useState(true);
    const [isVideoSampleComplete, setIsVideoSampleComplete] = useState(false);
    const [isShowCourseDetail, setIsShowCourseDetail] = useState(false);
    const [currentTabCourseDetail, setCurrentTabCourseDetail] = useState(1);
    

    const navigate = useNavigate();

    const {
        authStore: { token, userInfo },
        modalStore: { hide, openAlert, openWarningModal },
        userStore: { userInfoHeader, getUserInfoHeader, onAddTicketPlan, coursePeriodStatus, cancelAttendance }
    } = useStore();

    const handleBuyCourse = useBuyCourse(course?.id, {
        onSuccess: () => { getUserInfoHeader(); onFetchData && onFetchData(); },
        onAfterCancel: () => { handleSearch && handleSearch(); getUserInfoHeader(); }
    });

    useEffect(() => {
        if (!course) return;
        let totalNotAttended = (course?.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE) ? 0 : ((course.totalTimeCourse || 0) - (course.totalTimeJoinCourse || 0));
        totalNotAttended = totalNotAttended < 1 ? 0 : totalNotAttended;
        const totalAttended = course.totalTimeJoinCourse || 0;

        const dataset = {
            label: '受講割合',
            data: [totalAttended, totalNotAttended],
            backgroundColor: [
                '#fbb03b',
                '#0077b6'
            ]
        };

        setDataPieChart({
            ...dataPieChart,
            datasets: [
                dataset
            ]
        })

        
    }, [course])

    const courseStatusName = useMemo(() => {
        try {
            if (!course?.type?.length) return false;
            const types = [...course.type].map(e => Number(e));

            if (types.includes(0) && types.includes(1)) {
                return '精神薬学会認定薬剤師';
            }

            if (types.includes(0) && types.includes(2)) {
                return '漢方薬・生薬認定薬剤師';
            }

            if (types.includes(0) && types.includes(3)) {
                return '小児薬物療法認定薬剤師';
            }

            return false;
        } catch (error) {
            return false
        }
    }, [course?.type])

    const courseType = useMemo(() => {
        /**
            [0] -> 研修認定薬剤師 || 研修
            [0,1] -> 精神薬学会認定薬剤師 || 精神
            [0,2] -> 漢方薬・生薬認定薬剤師 || 研修 / 小児
            [0,3] -> 小児薬物療法認定薬剤師 || 研修 / 漢方
         */
        try {
            if (!course?.type?.length) return '';
            const types = [...course.type].map(e => Number(e));

            if (types.includes(0) && types.length === 1) {
                return {
                    status: 0,
                    content: "<span class='title-box xanh'>研修</span>"
                };
            }

            if (types.length === 2 && types.includes(0) && types.includes(1)) {
                return {
                    status: 1,
                    content: "<span class='title-box xanh'>研修</span><span class='title-box tim'>精神</span>"
                };
            }

            if (types.length === 2 && types.includes(0) && types.includes(2)) {
                return {
                    status: 2,
                    content: "<span class='title-box xanh'>研修</span><span class='title-box cam'>漢方</span>"
                };
            }

            if (types.length === 2 && types.includes(0) && types.includes(3)) {
                return {
                    status: 3,
                    content: "<span class='title-box xanh'>研修</span><span class='title-box vang'>小児</span>"
                };
            }

            if(course?.themeType === THEME_TYPE.NON_CERTIFICATE) {
                return {
                    content: ''
                }
            }

            return '';
        } catch (error) {
            return ''
        }
    }, [course?.type])

    const isM3u8 = useMemo(() => {
        return course?.sampleVideo && course.sampleVideo.toLowerCase().includes('m3u8');
    }, [course]);

    const courseDetailSidebar = useMemo(() => {
        return {
            CONTENT_LIST: {
                label: 'コンテンツ一覧',
                value: 1
            },
            ...(token && course?.statusUserCourse !== null ? {
                PROGRESS_RESULT: {
                    label: '進捗と結果',
                    value: 2
                }
            } : {})
            // COURSE_INFO: {
            //     label: '講座情報',
            //     value: 3
            // }
        }
    }, [course])

    const handleClickCompletionTest = (event) => {
        event.stopPropagation();
        navigate(`/course/${course?.id}/completion-test`);
    }

    const handleClickReTest = (event) => {
        event.stopPropagation();
        navigate(`/course/${course?.id}/completion-test`);
    }

    const handleClickReStudy = (event) => {
        event.stopPropagation();
        navigate(`/course/${course?.id}`);
    }

    const handleShowMore = (event) => {
        event.stopPropagation();
        setShowMore(prev => !prev);
    }

    const handleViewOldCourse = (event) => {
        event.stopPropagation();
        if(course?.isOldCourse) {
            if(userInfoHeader?.coursePeriodStart && userInfoHeader?.coursePeriodEnd &&
                moment().isSameOrBefore(moment(userInfoHeader?.coursePeriodEnd), 'date')) {
                navigate(`/course/${course?.id}`);
            } else {
                openAlert(MSG['error.view_old_course'], () => {
                    hide();
                }, 'auto', '閉じる');
            }
        }
    }



    const handleNavigateCourseDetail = (event) => {
        event.stopPropagation();
        if(token) {
            if(isShowCourseStatus(token, course)) {
                navigate(`/course/${course?.id}`);
            } else {
                handleViewOldCourse(event);
            }
        }
    }

    const handleViewContentList = () => {
        navigate(`/course/${course?.id}`);
    }

    const handleCancelAttendance = async () => {
        openWarningModal(MSG['cancel.attendance.update.confirm'], async () => {
            const res = await flowResult(cancelAttendance(course?.id));
            if (res) {
                handleSearch && handleSearch();
                getUserInfoHeader();
                ReactNotifications('success', MSG['inform.success.cancel.attendance']);
            }
        })
    }

    const courseRes = useMemo(() => {
        const courseDetail = toJS(course);
        const status = courseDetail?.statusUserCourse;
        let name = '';
        let color = '';
        let backgroundColor = '';
        switch (status) {
        case COURSE_STATUS_COMPLETE.USER_COURSE_NOT_ATTENDED: // 0
        case COURSE_STATUS_COMPLETE.USER_COURSE_ATTENDING: // 1
        case COURSE_STATUS_COMPLETE.USER_COURSE_NOT_DO_TEST: // 2
            name = '受講中';
            color = '#d96f04';
            backgroundColor = '#ffe9d5';
            break;
        case COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE: // 3
            name = '受講完了';
            color = '#00811d';
            backgroundColor = '#e4f1e7';
            break;
        default:
            name = '未受講';
            color = '#4d4d4d';
            backgroundColor = '#d5d5d566';
            break;
        }

        return { name, color, backgroundColor };
    }, [course])

    const options = {
        plugins: {
            legend: {
                display: true,
                position: 'right',
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                    padding: 5
                }
            }
        }
    };

    const isShowAchievement = course?.completionDate !== null;
    const isShowPieChart = course?.statusUserCourse !== null && course?.statusUserCourse !== undefined;
    const isShowOverlay = useMemo(() => {
        if (extractContent(course?.lecturerIntroduction || '').length > 10 ||
            extractContent(course?.description || '').length > 10 || isShowPieChart || isShowAchievement) {
            return true;
        }

        return false;
    }, [course, isShowPieChart, isShowAchievement])

    const isDisabled = isPublicDateAfterTodayJP(course?.publicDate);

    const joinBtnDisabledProps = (course?.isFreeCourse && userInfoHeader?.isCourseTicket &&
        userInfoHeader?.isFreeTicket && !userInfoHeader?.remainingFreeAmountTicket)
        ? {
            disabled: true,
            'data-bs-toggle': 'tooltip',
            'data-bs-placement': 'bottom',
            'title': '自由選択単位数の上限に達しているため、この講座を受講することはできません。'
        }
        : {};

    return (
        
        <div className={classNames('course-card-wrapper', isDisabled && 'course-card-wrapper-disabled')}>
            <div className={`${isDisabled ? 'show' : 'hide'}`}>
                <span style={{
                    padding: '8px 15px',
                    color: 'rgba(235, 0, 0, 1)',
                    backgroundColor: 'rgba(255, 235, 235, 1)',
                    borderRadius: '5px',
                    fontSize: '18px',
                    fontWeight: 'bold'
                    
                }}>{formatScheduledPublishDateJP(course?.publicDate)}</span>
            </div>
            <div className='course-card-container'>
                <div className="img-course">
                    {
                        course?.sampleVideo ? (
                            <VideoPlayer
                                options={{
                                    poster: course?.thumbnail,
                                    sources: [
                                        {
                                            src: course?.sampleVideo,
                                            type: isM3u8 ? 'application/x-mpegURL' : 'video/mp4'
                                        }
                                    ]
                                }}
                                width={320}
                                height={180}
                                disableForward={false}
                                onRunningVideo={() => setIsShowTitleVideoSample(false)}
                                onEndVideo={() => setIsVideoSampleComplete(true)}
                            />
                        ) : (
                            <div className='not-show-video'>
                                <img src={course?.thumbnail || '/images/img-1.png'} alt='' style={{'height': '100%', 'objectFit': 'fill'}}/>
                                <p>
                                    <Link to={SYSTEM_PATH.LOGIN}>ログイン</Link>後にご覧いただけます。
                                </p>
                            </div>
                        )
                    }
                    {
                        token && isShowTitleVideoSample && <p className="title-course-sample">サンプルコンテンツ</p>
                    }
                    {
                        isVideoSampleComplete && !isDisabled && isShowJoinCourse(token, course, userInfo) && (
                            <div className='video-sample-complete-overlay'>
                                <div className='course-action-btn'>
                                    <button
                                        type='button'
                                        onClick={handleBuyCourse}
                                        className='join-course join-course-btn'
                                        {...joinBtnDisabledProps}
                                    >
                                        受講する
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>

                <div className={classNames('course-content', !token && 'cursor-pointer-none')} onClick={handleNavigateCourseDetail}>
                    <p className="title-category line-clamp-1">{course?.themeName}</p>

                    <h3 className={classNames('title-3')}>
                        <span className={classNames('course-card-name', course?.isNew && 'icon-lecture-new')}>{course?.name}</span>
                        {
                            isShowCourseStatus(token, course) && (
                                <span className='item-course-status' style={{ 
                                    background: courseRes.backgroundColor,
                                    color: courseRes.color
                                }}>
                                    {
                                        courseRes.name === '受講完了' ? (
                                            <i className='fa-solid fa-check' style={{ color: courseRes.color }}></i>
                                        ) : (
                                            <div className='dot' style={{ backgroundColor: courseRes.color }}></div>
                                        )
                                    }
                                    {courseRes.name}
                                </span>
                            )
                        }
                    </h3>

                    <div className='d-flex align-items-center course-tag-container'>
                        {
                            course?.isSpecifiedCourse && (
                                <div className='course-specified-tag'>
                                    <img src='/images/icon-specified-course.svg' alt='' />
                                    <span>指定</span>
                                </div>
                            )
                        }
                        <div className='list-note'>
                            <p dangerouslySetInnerHTML={{ __html: courseType.content }} 
                                className='rows-center mg-b-0 d-flex flex-gap-10 align-items-center justify-content-center flex-wrap'
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: 'center'
                                }}
                            >
                            </p>
                        </div>
                    </div>
                    {/* <div className='d-flex align-items-center course-tag-container mg-t-10'>
                        {
                            course?.isSpecifiedCourse && (
                                <div className='course-specified-tag'>
                                    <img src='/images/icon-specified-course.svg' alt='' />
                                    研修指定講座
                                </div>
                            )
                        }
                    </div> */}

                    <div className="clock-video">
                        <ul>
                            <li className='li-0 d-flex align-items-center flex-gap-5'>
                                <i className='fa-regular fa-md fa-calendar' style={{ color: '#afb0b5' }}></i>
                                <span style={{ color: '#363946', fontWeight: '700' }}>{moment(course?.publicDate).format(DATE_YMD)}</span>
                            </li>
                            <li className='li-0 d-flex align-items-center flex-gap-5'>
                                <img className='mg-0' src='/images/icon2.svg' alt='' style={{ height: '15px', width: '15px' }} />
                                <span style={{ color: '#363946', fontWeight: '700' }}>{`${numberWithCommas(course?.totalLecture)}コンテンツ`}</span>
                            </li>
                            <li className='li-1 d-flex align-items-center flex-gap-5'>
                                <img className='mg-0' src='/images/icon1.svg' alt='' style={{ height: '15px', width: '15px' }} />
                                <span style={{ color: '#363946', fontWeight: '700' }}>{convertVideoDuration(course?.totalTime)} 分</span>
                            </li>
                            {
                                course?.level && (
                                    <li className='li-1 d-flex align-items-center flex-gap-5'>
                                        <img src='/images/icon-level-course.svg' alt='' style={{ color: '#afb0b5' }}/>
                                        <span style={{ color: '#363946', fontWeight: '700' }}>{LEVEL_COURSE_STRING[course.level]}</span>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
                            
                <div className={classNames('course-action-btn', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                    {
                        (course?.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_ATTENDING || course?.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_NOT_ATTENDED) && (
                            <button 
                                className={classNames(course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}
                                type='button' 
                                onClick={handleViewContentList}
                            >
                                受講を続ける
                            </button>
                        )
                    }
                    {
                        isShowJoinCourse(token, course, userInfo) &&
                        <button
                            type='button'
                            onClick={handleBuyCourse}
                            className={classNames('join-course join-course-btn', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}
                            {...joinBtnDisabledProps}
                        >
                            受講ボタン
                        </button>
                    }
                    {
                        isViewOldCourse(token, course, userInfo) && userInfoHeader?.numberTicket > 0 &&
                        <button type='button' onClick={handleViewOldCourse} className={classNames('join-course', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                            講座視聴
                        </button>
                    }
                    {
                        isShowCompletionTest(token, course, coursePeriodStatus) &&
                        <button type='button' onClick={handleClickCompletionTest} className={classNames('join-course', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                            修了テスト
                        </button>
                    }
                    {
                        isShowReTest(token, course, coursePeriodStatus) &&
                        <button type='button' onClick={handleClickReTest} className={classNames('join-course', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                            再テストの実施
                        </button>
                    }
                    {
                        isShowReStudy(token, course, coursePeriodStatus) &&
                        <button type='button' onClick={handleClickReStudy} className={classNames('join-course', 're-study-btn', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                            再受講する
                        </button>
                    }

                    {
                        isShowCancelButton(token, course) && (
                            <div
                                onClick={handleCancelAttendance}
                                className={classNames('cancel-attendance-btn', course?.isCancelAttendance && 'is-cancel-attendance')}
                            >
                                    受講をキャンセル
                            </div>
                        )
                    }

                    {
                        // #18006: the public course list no longer carries lecturesOfCourse, so the toggle
                        // would only open an empty panel for visitors who are not logged in.
                        token && (
                            <div
                                onClick={() => setIsShowCourseDetail(!isShowCourseDetail)}
                                className={classNames('d-flex align-items-center flex-gap-10 show-course-detail-btn', isShowCourseDetail && 'toggled', course?.isCancelAttendance && 'is-cancel-attendance', isDisabled && 'hide')}>
                                コンテンツ一覧
                                <img className='expand-icon' src='/images/icon-arrow-down-2.svg' alt='' />
                            </div>
                        )
                    }
                </div>
                
            </div>
            
            {/*  */}
            <div className='course-card-container course-detail' style={{ margin: 0 }}>
                <div className="img-course" style={{ visibility: 'hidden', height: '100%', width: '320px' }}/>
                <div className='course-card-detail' style={{borderTop: 'hidden'}}>
                    {
                        (course?.description || course?.lecturerIntroduction)  && (
                            <div style={{
                                border: '1px dashed #E5E5E5'
                            }}/>
                        )
                    }
                    <div className='course-info-container'>
                        {/* description */}
                        <ExpandableContent 
                            title="講座内容" 
                            htmlContent={course?.description} 
                        />

                        {/* lecturer */}
                        <ExpandableContent 
                            title="講師紹介" 
                            htmlContent={course?.lecturerIntroduction} 
                        />
                    </div>
                   
                   
                </div>
            </div>
            {/*  */}
            {
                isShowCourseDetail && (
                    <div className='course-card-container course-detail' style={{ margin: '20px 0 0 0' }}>
                        <div className="img-course" style={{ visibility: 'hidden', height: '100%', width: '320px' }}/>
                        <div 
                            className='course-card-detail' 
                            style={{
                                height: '100%',
                                border: '1px solid #E5E5E5',
                                borderRadius: '5px',
                                padding: '10px'
                            }}>
                            <div className='d-flex align-items-center gap-1'>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0_3857_6302" maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="14">
                                        <path d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z" fill="white" stroke="white" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.1665 8.00034V5.40234L8.4165 6.70134L10.6665 8.00034L8.4165 9.29934L6.1665 10.5983V8.00034Z" fill="black" stroke="black" stroke-width="1.41667" stroke-linejoin="round" />
                                    </mask>
                                    <g mask="url(#mask0_3857_6302)">
                                        <path d="M0 0H16V16H0V0Z" fill="black" />
                                    </g>
                                </svg>
                                <span className='fw-bold'>コンテンツ一覧</span>
                            </div>
                            {/* <div className='d-flex align-items-center sidebar'>
                                {
                                    Object.keys(courseDetailSidebar).map((item, index) => {
                                        return (
                                            <div
                                                key={index} 
                                                onClick={() => {
                                                    if (currentTabCourseDetail !== courseDetailSidebar[item].value) {
                                                        setCurrentTabCourseDetail(courseDetailSidebar[item].value);
                                                    }
                                                }}
                                                className={classNames('sidebar-item', currentTabCourseDetail === courseDetailSidebar[item].value && 'active')}
                                            >{courseDetailSidebar[item].label}</div>
                                        )
                                        
                                    })
                                }
                            </div> */}
                            <div className='course-detail-container'>
                                {
                                    currentTabCourseDetail === courseDetailSidebar?.CONTENT_LIST?.value && (
                                        <div className='content-list-container'>
                                            {
                                                course?.lecturesOfCourse && course.lecturesOfCourse?.length > 0 &&
                                                course.lecturesOfCourse.slice(0, 20).map((lecture, index) => (
                                                    <ContentListItem  
                                                        key={index}
                                                        id={lecture.id}
                                                        title={lecture.name}
                                                        lastTimeViewed={lecture.user_lecture_last_time_viewed}
                                                        videoLength={lecture.video_length}
                                                        status={lecture.status}
                                                        isEnableViewDetail={token && course?.statusUserCourse !== null}
                                                    />
                                                ))
                                            }
                                            {
                                                course?.lecturesOfCourse && course.lecturesOfCourse?.length > 20 && (
                                                    <div
                                                        onClick={() => navigate(`/course/${course?.id}`)}
                                                        className='content-view-more d-flex align-items-center justify-content-center flex-gap-5'>
                                                        <span>すべてのコンテンツを見る</span>
                                                        <i className='fa-solid fa-sm fa-angles-right'></i>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {/* {
                                    currentTabCourseDetail === courseDetailSidebar?.PROGRESS_RESULT?.value && (
                                        <div className='progress-result-container'>
                                            {
                                                token && (
                                                    <div className='row mg-t-10 chart-theme'>
                                                        {
                                                            isShowAchievement && (
                                                                <div className="col-md-6 col-sm-6 col-12 c1">
                                                                    <h3 className='title-intro text-center'>正答率</h3>
                                                                    <div className="chart-area chart-area1" style={{ width: 300, height: 200, margin: 'auto', paddingTop: 20 }}>
                                                                        <div className='chart-area1-item' style={{ width: 150, height: 150, margin: 'auto' }}>
                                                                            <CircularProgressbar
                                                                                strokeWidth={12}
                                                                                value={course?.achievement || 0}
                                                                                maxValue={100} text={`${course?.achievement || 0}%`}
                                                                                styles={buildStyles({
                                                                                    pathColor: '#FCB03B', textColor:
                                                                                        '#FCB03B', fontWeigth: 'bold'
                                                                                })} />
                                                                        </div>
                                                                        {course?.completionDate &&
                                                                            <p className="desc text-center"><span>実施日: </span>
                                                                                {moment(course?.completionDate).format(DATE_TIME_YMD)}
                                                                            </p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            isShowPieChart && (
                                                                <div className="col-md-6 col-sm-6 col-12">
                                                                    <h3 className='title-intro pd-l-60'>受講割合</h3>
                                                                    <div className="chart-area" style={{ width: 350, height: 300, margin: 'auto', marginTop: -55 }}>
                                                                        <Pie data={dataPieChart} options={options} width={250}
                                                                            height={250} />
                                                                    </div>
                                                                </div>
                                                            )

                                                        }
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )    
                                } */}
                                
                            </div>
                        </div>
                    </div>
                )
            }
            
        </div>
    )
}) 

export default CourseCard;

const ContentListItem = ({ id, title, lastTimeViewed, videoLength, status, isEnableViewDetail }) => {
    // ohter
    const navigate = useNavigate();

    let statusText = '未受講';
    let statusColor = '#6F6F6F';
    let borderColor = '#A8A8A8';

    if (lastTimeViewed > 0 && lastTimeViewed < videoLength) {
        statusText = '受講中';
        statusColor = '#FD7E00';
        borderColor = '#FFA600'
    }

    if (lastTimeViewed > 0 && lastTimeViewed === videoLength || status === 2) {
        statusText = '受講完了';
        statusColor = '#008D45';
        borderColor = '#00A50B'
    }

    // function
    const handleNavigateLectureDetail = () => {
        if (!isEnableViewDetail) return;
        navigate(`/lecture/${id}`);
    }
    return (
        <div
            onClick={handleNavigateLectureDetail}
            className={classNames('content-list-item', isEnableViewDetail && 'cursor-pointer')}>
            <div className='d-flex align-items-center gap-2'>
                <span className='title line-clamp-1'>{title}</span>
                <div className='video-time'>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.01438 0.0673226C7.93319 0.0107532 7.83294 -0.0114335 7.73546 0.00559758C7.63798 0.0226287 7.55119 0.077497 7.49399 0.158245C7.4368 0.238993 7.41383 0.339075 7.43011 0.436681C7.44638 0.534286 7.50058 0.621502 7.58088 0.679323L9.15588 1.79482C9.23707 1.85139 9.33733 1.87358 9.4348 1.85655C9.53228 1.83952 9.61907 1.78465 9.67627 1.7039C9.73347 1.62315 9.75643 1.52307 9.74015 1.42546C9.72388 1.32786 9.66968 1.24064 9.58938 1.18282L8.01438 0.0673226ZM2.16438 0.679323C2.24468 0.621502 2.29888 0.534286 2.31515 0.436681C2.33143 0.339075 2.30847 0.238993 2.25127 0.158245C2.19407 0.077497 2.10728 0.0226287 2.0098 0.00559758C1.91233 -0.0114335 1.81207 0.0107532 1.73088 0.0673226L0.155881 1.18282C0.0755786 1.24064 0.0213843 1.32786 0.00510873 1.42546C-0.0111668 1.52307 0.0117958 1.62315 0.0689924 1.7039C0.126189 1.78465 0.212983 1.83952 0.310459 1.85655C0.407935 1.87358 0.508193 1.85139 0.589381 1.79482L2.16438 0.679323ZM0.497381 5.37332C0.497381 4.213 0.958317 3.1002 1.77879 2.27973C2.59926 1.45926 3.71206 0.998323 4.87238 0.998323C6.0327 0.998323 7.1455 1.45926 7.96597 2.27973C8.78645 3.1002 9.24738 4.213 9.24738 5.37332C9.24738 6.53365 8.78645 7.64644 7.96597 8.46692C7.1455 9.28739 6.0327 9.74832 4.87238 9.74832C3.71206 9.74832 2.59926 9.28739 1.77879 8.46692C0.958317 7.64644 0.497381 6.53365 0.497381 5.37332ZM5.24738 3.12332C5.24738 3.02387 5.20787 2.92848 5.13755 2.85816C5.06722 2.78783 4.97184 2.74832 4.87238 2.74832C4.77293 2.74832 4.67754 2.78783 4.60722 2.85816C4.53689 2.92848 4.49738 3.02387 4.49738 3.12332V5.62332C4.49738 5.74832 4.55988 5.86582 4.66438 5.93532L6.16438 6.93532C6.20534 6.96328 6.25144 6.98284 6.30001 6.99287C6.34858 7.00289 6.39865 7.00319 6.44733 6.99373C6.49602 6.98427 6.54234 6.96525 6.58362 6.93777C6.6249 6.91028 6.66032 6.87489 6.68783 6.83362C6.71534 6.79236 6.73439 6.74605 6.74388 6.69737C6.75337 6.6487 6.75311 6.59862 6.74312 6.55005C6.73313 6.50147 6.7136 6.45536 6.68566 6.41438C6.65773 6.37341 6.62194 6.33838 6.58038 6.31132L5.24738 5.42282V3.12332Z" fill="#6F6F6F" />
                    </svg>
                    
                    <div className='video-length'>
                        {formatTimeFromVideoLength(videoLength)}
                    </div>
                </div>
                
            </div>
                
            {
                isEnableViewDetail ? (
                    <div style={{ color: statusColor, border: `solid 1px ${borderColor}` }} className='lecture-status d-flex align-items-center justify-content-center'>
                       
                        {
                            statusText
                        }
                    </div>
                ) : (
                    <div></div>
                )
            }
            
            
        </div>
    )
}